import { Box, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { checkOutInStepState } from "../state";

const CheckStepper = ({disableBack}: {disableBack?: boolean}) => {
	const theme = useTheme();

	const [checkStep, setCheckStep] = useRecoilState(checkOutInStepState);

	const steps = Array.from(new Array(checkStep.numSteps), (x, i) => i );

	const handleGoToStep = (e: React.SyntheticEvent, index: number) => {
		e.stopPropagation();

		setCheckStep({
			active: index,
			numSteps: checkStep.numSteps
		});
	}

	return (
		<Box sx={{display: "flex", justifyContent: "center", mt: theme.spacing(2), p: 'auto'}}>
			{
				steps
					.map((elem, index) => {
							if (checkStep.active === (index)) {
								return <Box sx={{border: "solid", borderColor: theme.palette.accent.main, bgcolor: theme.palette.accent.main, borderRadius: 2, p: theme.spacing(0.5), m: theme.spacing(1)}} key={`step${index}`}/>
							}
							else if (checkStep.active > index) {
								return !!disableBack ?
									<Box sx={{border: "solid", borderColor: theme.palette.neutral.dark, bgcolor: theme.palette.neutral.dark, borderRadius: 2, p: theme.spacing(0.5), m: theme.spacing(1)}}
										 key={`step${index}`}
									/> :
									<Box className={"cursor-pointer"}
										sx={{border: "solid", borderColor: theme.palette.accent.main, bgcolor: theme.palette.accent.main, borderRadius: 2, p: theme.spacing(0.5), m: theme.spacing(1)}}
										key={`step${index}`}
										onClick={(e: React.SyntheticEvent) => handleGoToStep(e, index)}
									/>
							} else {
								return <Box sx={{border: "solid", borderColor: theme.palette.accent.main, borderRadius: 2, p: theme.spacing(0.5), m: theme.spacing(1)}} key={`step${index}`} />
							}
					})
			}
		</Box>
	);
}

export default CheckStepper;
